import { render, staticRenderFns } from "./CouponRecover.vue?vue&type=template&id=20fc3318&scoped=true&"
import script from "./CouponRecover.vue?vue&type=script&lang=js&"
export * from "./CouponRecover.vue?vue&type=script&lang=js&"
import style0 from "./CouponRecover.vue?vue&type=style&index=0&id=20fc3318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc3318",
  null
  
)

export default component.exports